import React from 'react'
import { ReactComponent } from './facebook.svg'
import { MergeReactElementProps } from '@komune-io/g2-utils'

interface FacebookProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', FacebookProps>

export const FacebookIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#828282' } = props
    return <ReactComponent fill={color} ref={ref} {...props} />
  }
)
